export default __webpack_public_path__ + "static/media/B52_15.434dffd2.webp";